import { createRouter, createWebHistory } from 'vue-router'
import LandingPage from '@/views/public/LandingPage'

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'public-home',
      component: LandingPage,
    },
  ],
})

export default router
